import { Trans } from "next-i18next";

import { SubSectionData } from "@sellernote/shipda-kr/src/components/landing/LandingSubSection/types";

const SERVICE_INTRO_SECTION_DATA = {
  title: (
    <Trans
      i18nKey="page-company:인트로섹션_타이틀"
      components={{ mobileBr: <br className="only-mobile" /> }}
    />
  ),
  desc: <Trans i18nKey="page-company:인트로섹션_설명" />,
  backgroundImageUrl: "/assets/images/company/intro-section-bg.webp",
  backgroundMobileImageUrl: "/assets/images/company/intro-section-bg-m.webp",
};

const SUB_SECTION_PART1_DATA: SubSectionData = {
  chipLabel: <Trans i18nKey="page-company:우리의비전섹션_뱃지" />,
  title: <Trans i18nKey="page-company:우리의비전섹션_타이틀" />,
  desc: (
    <Trans
      i18nKey="page-company:우리의비전섹션_설명"
      components={{ strong: <strong /> }}
    />
  ),
  imageInfo: {
    url: "/assets/images/company/vision-section.webp",
    width: 350,
    height: 270,
  },
  mobileImageInfo: {
    url: "/assets/images/company/vision-section-m.webp",
    width: 328,
    height: 249,
  },
  layoutAlign: "left",
};

const SUB_SECTION_PART2_DATA: SubSectionData = {
  chipLabel: <Trans i18nKey="page-company:CEO섹션_뱃지" />,
  title: <Trans i18nKey="page-company:CEO섹션_타이틀" />,
  desc: <Trans i18nKey="page-company:CEO섹션_설명" />,
  imageInfo: {
    url: "/assets/images/company/ceo-section.webp",
    width: 406,
    height: 445,
  },
  mobileImageInfo: {
    url: "/assets/images/company/ceo-section-m.webp",
    width: 328,
    height: 140,
  },
  layoutAlign: "left",
};

const RECRUIT_SECTION_DATA = {
  title: <Trans i18nKey="page-company:채용섹션_타이틀" />,
  desc: <Trans i18nKey="page-company:채용섹션_설명" />,
  backgroundImageUrl: "/assets/images/company/recruit-section-bg.webp",
  backgroundMobileImageUrl: "/assets/images/company/recruit-section-bg-m.webp",
};

export {
  SERVICE_INTRO_SECTION_DATA,
  SUB_SECTION_PART1_DATA,
  SUB_SECTION_PART2_DATA,
  RECRUIT_SECTION_DATA,
};
